import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

const CutomCommitieeCard = ({ image, name, Position }) => {
  return (
    <Card sx={{ width: 200, height: 340 }}>
      <CardMedia
        component='img'
        alt='green iguana'
        image={image}
        sx={{
          padding: 1.3,
          height: 210, // Adjusting height to fit within padding
          width: '90%', // Ensures the image scales properly
          objectFit: 'cover', // Ensures it covers without distortion
          borderRadius: 2, // Optional: Adds rounded corners
        }}
      />
      <CardContent sx={{ padding: 1 }}>
        <Typography
          gutterBottom
          variant='h6'
          component='div'
          sx={{
            fontSize: '19px',
            fontWeight: 'bold',
            lineHeight: 1.2,
            paddingTop: -1,
          }}
        >
          {name}
        </Typography>
        <Typography
          variant='body2'
          sx={{ color: 'text.secondary', fontWeight: 'bold' }}
        >
          {Position}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CutomCommitieeCard;
